/* Satıcıya Sor — ürün sayfası istemcisi.
   Cevaplanmış soruları panelden çeker, yeni soruyu panele gönderir.
   Tüm metinler locale dosyalarından gelir (liquid data-* ile taşınır). */
(function () {
  'use strict';
  var root = document.getElementById('yake-qa');
  if (!root) return;

  var endpoint = (root.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
  var channel = root.getAttribute('data-channel') || '';
  var productId = root.getAttribute('data-product-id') || '';
  if (!endpoint || !productId) return;

  var list = document.getElementById('yakeQaList');
  var empty = document.getElementById('yakeQaEmpty');
  var form = document.getElementById('yakeQaForm');
  var toggle = root.querySelector('[aria-controls="yakeQaForm"]');
  var statusEl = document.getElementById('yakeQaStatus');
  var mineWrap = document.getElementById('yakeQaMine');
  var mineList = document.getElementById('yakeQaMineList');
  var MSG = {
    sending: root.getAttribute('data-msg-sending') || '…',
    success: root.getAttribute('data-msg-success') || 'OK',
    error: root.getAttribute('data-msg-error') || 'Hata',
    answer: root.getAttribute('data-label-answer') || '',
    edited: root.getAttribute('data-label-edited') || '',
    mine: root.getAttribute('data-label-mine') || '',
    pending: root.getAttribute('data-label-pending') || '',
    answered: root.getAttribute('data-label-answered') || '',
    notpub: root.getAttribute('data-label-notpub') || '',
    faq: root.getAttribute('data-label-faq') || '',
    speed: root.getAttribute('data-label-speed') || '',
  };

  /* Kendi sorularim: gonderimde verilen goruntuleme jetonu localStorage'da tutulur;
     bekleyen/yayinlanmayan soru yalnizca bu tarayicida, jetonla gorunur. */
  var MINE_KEY = 'yakeQaMine.v1';
  function readMine() {
    try {
      var all = JSON.parse(localStorage.getItem(MINE_KEY) || '[]');
      return Array.isArray(all) ? all : [];
    } catch (e) { return []; }
  }
  function saveMine(all) {
    try { localStorage.setItem(MINE_KEY, JSON.stringify(all.slice(-40))); } catch (e) {}
  }
  function addMine(entry) {
    var all = readMine();
    all.push(entry);
    saveMine(all);
  }

  function statusBadge(durum) {
    var cls = durum === 'answered' ? 'answered' : durum === 'rejected' ? 'rejected' : 'pending';
    var txt = durum === 'answered' ? MSG.answered : durum === 'rejected' ? MSG.notpub : MSG.pending;
    var b = el('span', 'yake-qa-badge ' + cls, txt);
    return b;
  }

  function renderMine(items) {
    if (!mineWrap || !mineList) return;
    mineList.textContent = '';
    if (!items.length) { mineWrap.hidden = true; return; }
    mineWrap.hidden = false;
    items.forEach(function (it) {
      var item = el('div', 'yake-qa-item');
      var q = el('p', 'yake-qa-q', it.soru + ' ');
      q.appendChild(statusBadge(it.durum));
      item.appendChild(q);
      if (it.durum === 'answered' && it.cevap) {
        var a = el('p', 'yake-qa-a');
        if (MSG.answer) a.appendChild(el('b', null, MSG.answer));
        a.appendChild(document.createTextNode(it.cevap));
        item.appendChild(a);
      }
      mineList.appendChild(item);
    });
  }

  function loadMine() {
    var pairs = readMine().filter(function (e) { return e.pid === productId; });
    if (!pairs.length) { renderMine([]); return; }
    fetch(endpoint + '/vitrin/sorularim', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: pairs.map(function (e) { return { id: e.id, token: e.t }; }) }),
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.ok) {
          renderMine((d.sorular || []).filter(function (s) { return s.durum !== 'answered'; }));
        }
      })
      .catch(function () {});
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function fmtDate(iso) {
    try {
      return new Date(iso).toLocaleDateString(document.documentElement.lang || 'tr');
    } catch (e) {
      return '';
    }
  }

  var faqWrap = document.getElementById('yakeQaFaq');
  var faqList = document.getElementById('yakeQaFaqList');
  var speedEl = document.getElementById('yakeQaSpeed');

  /* SSS'i urun ACIKLAMASININ hemen altina tasi (main-product'taki #yakeQaFaqSlot).
     Varyant degisiminde tema o bolgeyi yeniden render edip dugumumuzu silebilir;
     MutationObserver kopanı geri yerlestirir. Yuva yoksa SSS bolum icinde kalir. */
  function placeFaq() {
    if (!faqWrap || faqWrap.hidden) return;
    var slot = document.getElementById('yakeQaFaqSlot');
    if (slot && !slot.contains(faqWrap)) {
      faqWrap.classList.add('yake-qa-faq--inline');
      slot.appendChild(faqWrap);
    }
  }
  var faqObserver = null;
  function watchFaqSlot() {
    var slot = document.getElementById('yakeQaFaqSlot');
    if (!slot || faqObserver) return;
    var host = slot.closest('product-rerender') || slot.parentElement;
    if (!host) return;
    faqObserver = new MutationObserver(function () {
      if (faqWrap && !faqWrap.hidden && !document.contains(faqWrap)) {
        requestAnimationFrame(placeFaq);
      } else {
        requestAnimationFrame(placeFaq);
      }
    });
    faqObserver.observe(host, { childList: true, subtree: true });
  }

  function renderFaq(items) {
    if (!faqWrap || !faqList) return;
    faqList.textContent = '';
    if (!items.length) { faqWrap.hidden = true; return; }
    items.forEach(function (it) {
      var row = el('div', 'yake-qa-faq-qa');
      row.appendChild(el('p', 'yake-qa-faq-q', it.soru));
      row.appendChild(el('p', 'yake-qa-faq-a', it.cevap));
      faqList.appendChild(row);
    });
    faqWrap.hidden = false;
    placeFaq();
    watchFaqSlot();
  }

  function renderSpeed(hours) {
    if (!speedEl || !hours || !MSG.speed) return;
    speedEl.textContent = MSG.speed.replace('{{ hours }}', hours);
    speedEl.hidden = false;
  }

  function render(items) {
    list.textContent = '';
    if (!items.length) {
      empty.hidden = false;
      list.hidden = true;
      return;
    }
    empty.hidden = true;
    list.hidden = false;
    items.forEach(function (it) {
      var item = el('div', 'yake-qa-item');
      var q = el('p', 'yake-qa-q', it.soru + ' ');
      var meta = el('span', 'yake-qa-meta', '— ' + (it.ad || '') + ' · ' + fmtDate(it.tarih) + (it.duzenlendi && MSG.edited ? ' · ' + MSG.edited : ''));
      q.appendChild(meta);
      item.appendChild(q);
      var a = el('p', 'yake-qa-a');
      if (MSG.answer) a.appendChild(el('b', null, MSG.answer));
      a.appendChild(document.createTextNode(it.cevap || ''));
      item.appendChild(a);
      list.appendChild(item);
    });
  }

  fetch(endpoint + '/vitrin/sorular?productId=' + encodeURIComponent(productId) + '&vendor=' + encodeURIComponent(root.getAttribute('data-vendor') || '') + '&type=' + encodeURIComponent(root.getAttribute('data-product-type') || '') + '&channel=' + encodeURIComponent(channel))
    .then(function (r) { return r.json(); })
    .then(function (d) {
      if (d && d.ok) {
        render(d.sorular || []);
        renderFaq(d.sss || []);
        renderSpeed(d.yanitSaat);
      } else { empty.hidden = false; }
    })
    .catch(function () { empty.hidden = false; });

  loadMine();

  if (toggle && form) {
    toggle.addEventListener('click', function () {
      form.hidden = !form.hidden;
      toggle.setAttribute('aria-expanded', form.hidden ? 'false' : 'true');
      if (!form.hidden) {
        var first = form.querySelector('input[name="name"]');
        if (first) first.focus();
      }
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      statusEl.className = 'yake-qa-status text-sm';
      statusEl.textContent = MSG.sending;
      btn.disabled = true;
      var payload = {
        channel: channel,
        productId: productId,
        handle: root.getAttribute('data-handle') || '',
        title: root.getAttribute('data-product-title') || '',
        vendor: root.getAttribute('data-vendor') || '',
        name: form.elements.name.value,
        email: form.elements.email.value,
        question: form.elements.question.value,
        website: form.elements.website.value,
      };
      fetch(endpoint + '/vitrin/soru', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          btn.disabled = false;
          if (d && d.ok) {
            statusEl.classList.add('ok');
            statusEl.textContent = d.message || MSG.success;
            if (d.id && d.token) {
              addMine({ id: d.id, t: d.token, pid: productId, ts: Date.now() });
              loadMine();
            }
            form.reset();
          } else {
            statusEl.classList.add('err');
            statusEl.textContent = (d && d.error) || MSG.error;
          }
        })
        .catch(function () {
          btn.disabled = false;
          statusEl.classList.add('err');
          statusEl.textContent = MSG.error;
        });
    });
  }
})();
